























































import { defineComponent, PropType, computed, ref } from '@nuxtjs/composition-api';
import useWindowResize from '@/hooks/useResizeWindow.js';
import KEDrawer from '@/components/atoms/KEDrawer.vue';
import AtomsProductDropdown from '@/components/atoms/ProductDropdown.vue';
import type { ProductVariationType } from '@/components/atoms/ProductDropdown.vue';

export default defineComponent({
  name: 'ProductVariations',
  components: {
    KEDrawer,
    AtomsProductDropdown
  },
  props: {
    label: { type: String, required: true },
    drawerTitle: { type: String, default: '' },
    list: { type: Array as PropType<ProductVariationType[]>, default: () => [] },
    selectedId: { type: String, default: '' },
    placeholder: { type: String, default: '' }
  },
  setup(props, { emit }) {
    const { isDesktop } = useWindowResize();
    const hasOptions = computed(() => props.list.length > 0);
    const selectedItem = computed(
      () => props.list.find(v => v.id === props.selectedId) || props.list[0]
    );

    const open = ref(false);

    const selectedLabel = computed(() => selectedItem.value?.name ?? props.placeholder);

    const onSelected = (id: string) => {
      emit('update:selectedId', id);
      emit('selected', id);
      open.value = false;
    };

    const toggle = () => {
      if (!hasOptions.value) {
        return;
      }

      open.value = !open.value;
    };
    const close = () => (open.value = false);

    return {
      isDesktop,
      hasOptions,
      open,
      toggle,
      close,
      selectedItem,
      selectedLabel,
      onSelected
    };
  }
});
